import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as Middleware from "@middlewares/index";

// TODO: убрать классовый компонент
// TODO: поправить верстку и адаптив

interface PropsInterface {}

interface StateInterface {}

class Default extends React.Component<PropsInterface, StateInterface> {
  public render() {
    return (
      <div className="modal-wrap">
        <button
          className="modal__close"
          onClick={() => {
            Middleware.Ui.Modal.close();
          }}
        />
        <div className="modal modal--content">
          <div className="modal__header">
            <h1 className="modal__title">Что такое баллы Лоялти?</h1>
          </div>
          <div className="modal__body">
            <p>
              Profi.Travel Loyalty - это система лояльности для турагентов,
              запущенная командой Profi.Travel. Суть её в том, что турагент
              получает баллы за участие в онлайн-мероприятиях и бронировании
              турпродукта в течение года. Это позволяем ему не только повышать
              свой профессиональный уровень, но и участвовать в розыгрыше
              призов.
            </p>
            <p>
              Зарегистрировавшись на онлайн-интенсив вы автоматически попали в
              Profi.Travel Loyalty и вам начисленны баллы за регистрацию. Вы
              можешь заработать баллы прямо сейчас и оплатить ими выставку.
            </p>
            <h2>Как получить баллы прямо сейчас?</h2>
            <div className="modal__rating-star-grid">
              <div>Регистрация на онлайн-интенсив</div>
              <div>+10 баллов</div>
              <div>
                Просмотр стендов экспонентов онлайн-мероприятия (один раз за
                онлайн-мероприятие)
              </div>
              <div>+10 баллов </div>
              <div>
                Скачивание каталогов экспонентов онлайн-мероприятия (за каждый
                каталог один раз за онлайн-мероприятие)
              </div>
              <div>+15 баллов</div>
              <div>
                Внесение брони на сайте Loyalty (доступно для тех, кто
                осуществлял бронирование у{" "}
                <a href="https://profi.travel/loyalty#partners" target="_blank">
                  партнёров программы Loyalty
                </a>
                )
              </div>
              <div>от 100 баллов</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(
  connect(
    (Store: any) => {
      return { Store };
    },
    (Dispatch: any) => {
      return { Dispatch: (action: any) => Dispatch(action) };
    }
  )(Default)
);
